import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-forms',
  templateUrl: './admin-forms.component.html',
  styleUrls: ['./admin-forms.component.scss']
})
export class AdminFormsComponent implements OnInit {

  @ViewChild('HeaderEl', { read: ElementRef, static: false }) headerView!: ElementRef;
  @ViewChild('SidebarEl', { read: ElementRef, static: false }) sidebarView!: ElementRef;
  @ViewChild('RightbarEl', { read: ElementRef, static: false }) rightbarView!: ElementRef;
  @ViewChild('mainContainer', { read: ElementRef, static: false }) mainContainerView!: ElementRef;
  @ViewChild('FooterEl', { read: ElementRef, static: false }) footerView!: ElementRef;
  @ViewChild('FooterStickyEl', { read: ElementRef, static: false }) FooterStickyView!: ElementRef;
  
  constructor(
    private renderer: Renderer2,
    private translateSvc: TranslateService
    ) {       
      console.log(translateSvc.getDefaultLang());
    }

  ngOnInit(): void {
    this.translateSvc.setDefaultLang('es-ES');
  }

  ngAfterViewInit() {
    this.renderer.setStyle(this.mainContainerView.nativeElement, 'margin-top', (this.headerView.nativeElement.offsetHeight + 15) + 'px');
    this.renderer.setStyle(this.sidebarView.nativeElement, 'padding-top', (this.headerView.nativeElement.offsetHeight + 25) + 'px');
    this.renderer.setStyle(this.rightbarView.nativeElement, 'padding-top', (this.headerView.nativeElement.offsetHeight + 20) + 'px');    
    if(this.footerView)
    {
      this.renderer.setStyle(this.rightbarView.nativeElement, 'padding-bottom', this.footerView.nativeElement.offsetHeight + 'px');
      this.renderer.setStyle(this.footerView.nativeElement, 'padding-bottom', 'calc(env(safe-area-inset-bottom) +' + (this.FooterStickyView.nativeElement.offsetHeight + 20) + 'px)');
      this.renderer.setStyle(this.mainContainerView.nativeElement, 'min-height', (window.innerHeight - this.headerView.nativeElement.offsetHeight - this.footerView.nativeElement.offsetHeight - 15) + 'px');
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    let header = document.getElementsByTagName('app-header')[0];
    let main = document.getElementsByTagName('html')[0];

    if (main.scrollTop > 15) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  }

}
